// Single source of truth for contact info
export const BRAND = "ABL Experts";
export const PHONE_RAW = "+919133860400"; // E.164 format
export const PHONE_DISPLAY = "+91 91338 60400";
export const WHATSAPP_RAW = "919133860400";
export const WHATSAPP_MSG = encodeURIComponent(
  "Hi ABL Experts, I am looking for septic tank cleaning service in visakhapatnam"
);
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_RAW}?text=${WHATSAPP_MSG}`;
export const TEL_LINK = `tel:${PHONE_RAW}`;

// Fires Google Ads "Lead" conversion. Safe to call from any click handler;
// does NOT intercept navigation (the href/target on the link continues to work).
export const trackLeadConversion = () => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
      window.gtag_report_conversion();
    }
  } catch (e) {
    // swallow — never block the user from calling/WhatsApping
  }
};
